export const RequestStatus = {
  APPROVED: "approved",
  REJECTED: "rejected",
};
